// pages/ValidarComprovante.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function ValidarComprovante() {
  const { id } = useParams();

  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const fetchComprovante = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/comprovante/validarcomprovante/${id}`);
        setDados(res.data);
      } catch (err) {
        setErro("Comprovante não encontrado ou inválido");
      } finally {
        setLoading(false);
      }
    };

    fetchComprovante();
  }, [id]);

  if (loading) {
    return <div className="container">Validando comprovante...</div>;
  }

  if (erro) {
    return (
      <div className="container">
        <div className="card" style={{ borderLeft: "6px solid #ef4444" }}>
          <h2>❌ Comprovante inválido</h2>
          <p>{erro}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">

      <div className="card" style={{ borderLeft: "6px solid #22c55e" }}>
        <h2>✅ Comprovante válido</h2>

        <hr />

        <p><strong>Cliente:</strong> {dados.cliente}</p>
        <p><strong>CPF:</strong> {dados.cpf}</p>
        <p><strong>Processo:</strong> {dados.processo}</p>
        <p><strong>Valor:</strong> R$ {dados.valor}</p>
        <p><strong>Data:</strong> {dados.dataPagamento}</p>
        <p><strong>Status:</strong> {dados.status}</p>

        <hr />

        <small>ID: {dados.id}</small>
      </div>

    </div>
  );
}